import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./SearchBar.css";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const modules = [
  {
    title: "Woning huren",
    description:
      "Ga je een woning huren? Check hier je huurovereenkomst. Ga je een woning huren? Check hier je huurovereenkomst.",
    redirectUri: "housing/rent",
  },
  {
    title: "Woning kopen",
    description: "Ga je binnenkort een woning kopen? Check hier je koopakte zodat je geen onnodige risico's loopt.",
    redirectUri: "housing/buy",
  },
  {
    title: "Arbeidscontract controleren",
    description: "Binnenkort beschikbaar",
    disabled: false,
    redirectUri: "career/labour-contract",
  },
  {
    title: "Bedrijfsruimte huren",
    description: "Binnenkort beschikbaar",
    disabled: true,
  },
];

const SearchBar = () => {
  const [inputValue, setInputValue] = useState(null);
  const navigate = useNavigate();

  const defaultProps = {
    options: modules,
    getOptionLabel: (option) => option.title,
  };

  const filterOptions = (options, { inputValue }) => {
    if (inputValue.length < 1) {
      return [];
    }

    return options.filter(
      (option) => option.title.toLowerCase().includes(inputValue.toLowerCase())
      //   || option.description.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  function changeHandler(newInputValue) {
    console.log(newInputValue);
    navigate(newInputValue.redirectUri);
  }

  return (
    <Autocomplete
      {...defaultProps}
      noOptionsText={
        !inputValue || inputValue?.title?.length < 1
          ? t("searchAModule")
          : t("noModules")
      } // Dynamische tekst
      filterOptions={filterOptions}
      onChange={(event, newInputValue) => changeHandler(newInputValue)} // Houd de invoer bij
      renderOption={(props, option) => {
        const isDisabled = option.disabled; // Controleer of de optie disabled is
        return (
          <li
            {...props}
            className={`search-option ${isDisabled ? "disabled" : ""}`}
            style={{
              pointerEvents: isDisabled ? "none" : "auto", // Maak de optie niet klikbaar
              opacity: isDisabled ? 0.5 : 1, // Verlaag de zichtbaarheid van disabled opties
            }}
          >
            <span className="search-option-title">{option.title}</span>
            <span className="search-option-desc">{option.description}</span>
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
          placeholder={t("searchAModule")}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
      slotProps={{
        popper: {
          sx: {
            "& .MuiAutocomplete-listbox": {
              backgroundColor: "#FFFFFF", // Witte achtergrond voor de lijst
              maxHeight: "200px",
              overflowY: "auto",
            },
          },
        },
      }}
      sx={{
        borderRadius: "4px",
        "& .MuiInputBase-root": {
          backgroundColor: "#FFFFFF",
          border: "1px solid #E0E0E0",
          padding: "10px 0px 10px 10px",
          fontSize: "14px",
          fontWeight: 400,
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "4px",
          padding: "0px 0px 0px 10px",
          border: "1px solid #E0E0E0",
        },
        "& .MuiInputBase-input": {
          fontSize: "14px",
        },
        "& .MuiAutocomplete-popper": {
          fontSize: "14px",
          fontWeight: 400,
          backgroundColor: "#FFFFFF!important",
        },
        width: "min(100%, 400px)",
      }}
    />
  );
};

export default SearchBar;
